<template>
  <div class="bg-white border">
    <!-- Layer List -->
    <div class="d-flex h-100 flex-column">
      <div class=" h-0 overflow-y-auto flex-grow-1 overflow-x-hidden">
        <ul class="m-0 my-3 p-0" >
          <li class="d-flex align-items-center px-3 font-12 justify-content-between">
            <span class="pr-2 disabled">Slide Element</span>
            <span>{{ getCurrentActiveCanvasObjects.length }}</span>
          </li>
         
        </ul>
        <ul class="m-0 my-3 p-0" ref="sortableList">
          <!-- <li class="d-flex align-items-center px-3 font-12 justify-content-between">
            <span class="pr-2 disabled">Slide Element</span>
            <span>{{ getCurrentActiveCanvasObjects.length }}</span>
          </li> -->
          <!-- Check if there are active canvas objects -->
          <template v-if="getCurrentActiveCanvasObjects.length === 0">
            <li class="text-center p-3 font-12">No objects found</li>
          </template>
          <template v-else>
            <!-- Loop through the objects of the active canvas -->
            <li 
              v-for="(object,index) in [...getCurrentActiveCanvasObjects].reverse()" 
              :key="object.id"
              @click="selectObject(object)"
              :currentIndex="index"
              :class="{ 'selected-object': selectedObject && selectedObject.id === object.id }"
              :id="object.id"
               :data-original-index="getCurrentActiveCanvasObjects.length - index - 1"
            >
              <div class="d-flex align-items-center px-3">
                <!-- Display object type icon -->
                <div class="objectIcon ml-0 mr-2">
                  <i :class="getIconClass(object.type) + ' font-12'"></i>
                </div>
                <!-- Display object type as title -->
                <div class="objectDetails">
                  <div class="objectType font-12">{{ object.type || 'Unknown Type' }}</div>
                </div>
              </div>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import Sortable from 'sortablejs';

export default {
  name: 'LayersPanel',
  data() {
    return {
      isSidebarVisible: false, // Track the visibility of the sidebar
      activeIndex: 0,
      selectedObject: null, // Track the currently selected object
    };
  },
  computed: {
    CanvasHtml() {
      return this.$store.getters.getCanvasInstances;
    },
    canvasInstances() {
      return this.$store.getters.getCanvasInstances;
    },
    activeCanvasIndex() {
      return this.$store.getters.getCanvasIndex;
    },
    getCurrentActiveCanvasObjects(){
      return this.$store.getters.getCurrentActiveCanvasObjects;
    },
    activeCanvasObjects() {
      if (this.canvasInstances && this.canvasInstances[this.activeCanvasIndex]) {
        return this.canvasInstances[this.activeCanvasIndex].objects;
      }
      return [];
    },
  },
  watch: {
    "$store.state.canvasRefs": {
      handler(newValue, oldValue) {
        this.$store.dispatch("createNewCanvas");
        console.log(newValue, oldValue);
      },
      deep: true,
    },
  },
  mounted() {
    Sortable.create(this.$refs.sortableList, {
      animation: 150,
      onEnd: this.onEnd,
    });
  },
  methods: {
    onEnd(event) {
      debugger // eslint-disable-line no-debugger
    console.log(event)
    let value;

    const oldIndex = this.getCurrentActiveCanvasObjects.length - event.oldIndex - 1;
          const newIndex = this.getCurrentActiveCanvasObjects.length - event.newIndex - 1;
          console.log(`Moved item from index ${oldIndex} to index ${newIndex}`);

    value = { oldindex : oldIndex , newIndex:newIndex    }
   
    this.$store.dispatch("zIndexObjects", value);
  },
    toggleSidebar() {
      this.isSidebarVisible = !this.isSidebarVisible; 
    },
    setActiveIndex(value) {
      this.activeIndex = value;
      this.$store.dispatch("setActiveCanvasIndex", value);
      this.setCurrentTargetnull();
    },
    duplicateCanvasInstance(index) {
      let objToDuplicate = this.CanvasHtml[index];
      let newObjArray = objToDuplicate.objects.map(x => {
        return {
          ...x,
          id: `${x.id.split("_")[0]}_${uuidv4()}`,
        };
      });

      let newObj = {
        id: `canvas_${uuidv4()}`,
        size: {
          width: objToDuplicate.size.width,
          height: objToDuplicate.size.height,
        },
        zoomRatio: objToDuplicate.zoomRatio,
        bgColor: "#fff",
        objects: newObjArray,
      };

      let obj = { index: index, newObj };
      this.$store.dispatch("duplicateCanvas", obj);
      this.setActiveIndex(index + 1);
      this.setCurrentTargetnull();
    },
    removeCanvas(id) {
      this.$store.dispatch("removeCanvas", id);
      this.setActiveIndex(0);
      this.$store.dispatch("setActiveCanvasIndex", 0);
      this.setCurrentTargetnull();
    },
    setCurrentTargetnull() {
      this.$store.dispatch("setActiveObject", null);
    },
    selectObject(object) {
      this.selectedObject = object; // Set the selected object
      let obj = { target: document.querySelector(`[data-id-t=${object.id}]`), id: object.id };
      this.$store.dispatch("setActiveObject", obj); // Dispatch action to set the active object in Vuex
      console.log('Selected Object:', obj);
    },
    getIconClass(objectType) {
      switch (objectType.toLowerCase()) {
        case 'text':
          return 'fas fa-font';
        case 'img':
          return 'fas fa-image';
        case 'video':
          return 'fas fa-video';
        case 'circle':
          return 'fas fa-circle';
        case 'clockapp':
          return 'fa fa-clock';
        case 'weatherapp':
          return 'fa fa-cloud';
        case 'youtubeapp':
          return 'fa fa-youtube';
        case 'qrcodeapp':
          return 'fa fa-qrcode';
        case 'calendarapp':
          return 'fa fa-calendar-days';
        case 'newsapp':
          return 'fa fa-newspaper';
        case 'webpageapp':
          return 'fa fa-globe';
        case 'vimeoapp':
          return 'fa-brands fa-vimeo-v';
        case 'ellipse':
          return 'fas fa-circle-notch';
        case 'rectangle':
          return 'fas fa-square';
        case 'line':
          return 'fas fa-minus';
        case 'triangle':
          return 'fas fa-exclamation-triangle';
        case 'polygon':
          return 'fas fa-shapes';
        default:
          console.warn(`Unknown object type: ${objectType}`);
          return 'fas fa-question';
      }
    },
  },
};
</script>

<style scoped>
/* Add relevant styles for the sidebar */
.layers-sidebar {
  background-color: #333;
  width: 300px;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1000;
  padding: 20px;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.5);
}

.slideImg {
  border: 5px solid #ccc;
  border-radius: 5px;
  height: 50px;
  width: 105px;
  cursor: pointer;
}

.rotate-90 {
  transform: rotate(90deg);
}

.slidelistitems.active .slideImg {
  border-color: #8e42ff;
}

.dotsimg {
  width: 1rem;
}

.overflow-x-hidden {
  overflow-x: hidden;
}

.overflow-y-auto {
  overflow-y: auto;
}

.h-0 {
  height: 0;
}

.addSlideBtn {
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 1.5rem;
  padding-left: 0.95rem;
  padding-right: 0.95rem;
  padding-bottom: 0.5rem;
  padding-top: 0.5rem;
  border-radius: 0.25rem;
  width: 100%;
  display: inline-block;
  background-color: rgb(248 249 250);
  border-color: rgb(221 226 229);
  border-width: 1.5px;
  color: rgb(73 80 87);
}

.objectIcon {
  font-size: 1rem; /* Adjust size as needed */
  color: #6c757d; /* Change color as needed */
  margin-left: 10px;
}

.objectDetails {
  display: flex;
  flex-direction: column;
  cursor: pointer;
}

.objectType {
  font-weight: 600;
  color: #333;
  margin-right: 5px;
}

.font-12 {
  font-size: 12px;
}

.sortable-list {
  list-style: none;
  padding: 0;
}

.sortable-list li {
  padding: 10px;
  background-color: #f8f9fa;
  margin-bottom: 5px;
  border: 1px solid #ddd;
}

.selected-object { /* Add styles for the selected object */
  background-color: #d1e7dd; /* Light green background for selection */
}
</style>
